<template>
  <div class="beta-banner">
    <strong>内测免费</strong> · 视频文件保留 24 小时请及时下载 · 后期将收费
    <div class="quota-boost-notice">{{ freeQuotaNotice }}</div>
    <div v-if="quotaHint" class="quota-hint">{{ quotaHint }}</div>
  </div>
</template>

<script>
import { fetchQuotaPlans, fetchMyQuota } from '../api/auth';
import { planLabel } from '../constants/planLabels';
import { FREE_QUOTA_BETA_NOTICE } from '../constants/freeQuotaNotice';
import { formatFileSizeMb } from '../utils/formatQuota';
import { getAccessToken } from '../utils/authStorage';

function buildQuotaHint(limits, usage) {
  const planName = planLabel(limits.planCode);
  const base = `当前档位（${planName}）：${formatFileSizeMb(limits.maxFileMb)} / ${limits.maxDurationMin}分钟 / ${limits.slicesPerDay}次任务/日`;
  if (!usage) {
    return base;
  }
  const remainDay = Math.max(0, limits.slicesPerDay - (usage.slicesToday || 0));
  const remainMonth = Math.max(0, limits.slicesPerMonth - (usage.slicesMonth || 0));
  return `${base} · 今日剩余 ${remainDay} 次 · 本月剩余 ${remainMonth} 次`;
}

export default {
  name: 'BetaBanner',
  data() {
    return {
      quotaHint: '',
      freeQuotaNotice: FREE_QUOTA_BETA_NOTICE,
    };
  },
  async mounted() {
    await this.refresh();
  },
  methods: {
    async refresh() {
      try {
        if (getAccessToken()) {
          const me = await fetchMyQuota();
          if (me && me.limits) {
            this.quotaHint = buildQuotaHint(me.limits, me);
            return;
          }
        }
        const plans = await fetchQuotaPlans();
        const freePlan = (plans || []).find(p => p.planCode === 'FREE');
        if (freePlan) {
          this.quotaHint = `免费档：${formatFileSizeMb(freePlan.maxFileMb)} / ${freePlan.maxDurationMin}分钟 / ${freePlan.slicesPerDay}次任务/日`;
        }
      } catch (e) {
        // ignore
      }
    },
  },
};
</script>

<style scoped>
.beta-banner {
  background: rgba(15, 118, 110, 0.35);
  border: 1px solid rgba(45, 212, 191, 0.35);
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  color: #ccfbf1;
  margin-bottom: 16px;
}
.quota-boost-notice {
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 6px;
  background: rgba(251, 191, 36, 0.18);
  border: 1px solid rgba(251, 191, 36, 0.55);
  color: #fef3c7;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.5;
}
.quota-hint { margin-top: 6px; color: #99f6e4; font-size: 12px; }
</style>
